import { useTranslation } from "react-i18next";
import { Panel, PanelHeaderTemplateOptions } from 'primereact/panel';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { formatarParaMoedaBRL } from "../../../utils";
import NadaConsta from "../../../components/nadaConsta";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import { Score } from "../../../components/Score";
import { fixEncoding } from "../../../utils/stringUtils";

export default function CreditoPositivoPlus({
  creditoPositivo
}: {
  creditoPositivo: any
}) {
  const { t } = useTranslation();

  const createHeaderTemplate = (title: string, hasOccurrences: boolean) => (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return (
      <div className={className}>
        {hasOccurrences ? (
          <div>
            <span style={{ color: '#C70039' }} className="pi-consulta pi pi-exclamation-triangle"></span>
            <span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{title}</span>
          </div>
        ) : (
          <span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{title}</span>
        )}
      </div>
    );
  };

  const getRange = (pontuacao: number) => {

    if (pontuacao >= 400 && pontuacao < 500) {
      return 'REGULAR'
    }

    if (pontuacao >= 500 && pontuacao < 600) {
      return 'BOM'
    }
    if (pontuacao >= 600) {
      return 'OTIMO'
    }

    return 'RUIM'
  }

  const headerTemplatePendencia2 = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {creditoPositivo.PEND_REFIN && creditoPositivo.PEND_REFIN.OCORRENCIAS && creditoPositivo.PEND_REFIN.OCORRENCIAS.length > 0 ? (<div><span style={{ color: '#C70039' }} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('pendencia2')}</span></div>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('pendencia2')}</span>)}</div>;
  }

  const headerTemplatePendencia3 = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {creditoPositivo.PEND_VENCIDAS && creditoPositivo.PEND_VENCIDAS.OCORRENCIAS && creditoPositivo.PEND_VENCIDAS.OCORRENCIAS.length > 0 ? (<div><span style={{ color: '#C70039' }} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('pendencia3')}</span></div>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('pendencia3')}</span>)}</div>;
  }

  const getResumoProtesto = (data: any) => {
    const resumos: any[] = [];
    if (data && data.OCORRENCIAS && data.OCORRENCIAS.length > 0) {
      resumos.push({
        icon: 'pi pi-chart-line',
        label: 'Quantidade Comarcas',
        value: 0
      })
      resumos.push({
        icon: 'pi pi-gauge',
        label: 'Quantidade Protestos',
        value: 0
      })
      resumos.push({
        icon: 'pi pi-dollar',
        label: 'Valor Total Protestos',
        value: '0'
      })
      let valorTotal = 0.0
      let quantidade = 0;
      const comarcas: any[] = []
      data.OCORRENCIAS.forEach((prot: any) => {
        quantidade++;
        valorTotal = valorTotal + Number(prot.VALOR.replace('.', '').replace(',', '.'))
        if (!comarcas.includes(prot.COMARCA)) {
          comarcas.push(prot.COMARCA)
        }
      });
      resumos[0].value = comarcas.length;
      resumos[1].value = quantidade;
      resumos[2].value = formatarParaMoedaBRL(valorTotal);
    }

    return resumos;
  }

  const headerTemplateProtesto = (data: any) => (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {data && data.OCORRENCIAS && data.OCORRENCIAS.length > 0 ? (<div><span style={{ color: '#C70039' }} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('protestos')}</span></div>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('protestos')}</span>)}</div>;
  }

  const renderProtestoSection = (data: any) => {
    if (!data) return null;

    return (
      <Panel headerTemplate={headerTemplateProtesto(data)}>
        {!data.OCORRENCIAS || data.OCORRENCIAS.length === 0 ? (<NadaConsta />) : (<>
          <div className="flex-consulta  flex-wrap gap-3">
            {getResumoProtesto(data).map((item: any, index: number) => (

              <Card className='flex-1' style={{ backgroundColor: '#2e2eb8' }} key={index}>
                <div className="flex-consulta  justify-content-between gap-5">
                  <div className="flex-consulta  flex-column gap-1">
                    <span style={{ color: 'white' }} className=" text-sm">{item.label}</span>
                    <span style={{ color: 'white' }} className="font-bold text-lg">{item.value}</span>
                  </div>
                  <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor: 'white', color: '#183462' }}>
                    <i className={item.icon} />
                  </span>
                </div>
              </Card>

            ))}
          </div>
          <br></br>
          <DataTable size="small" value={data.OCORRENCIAS} tableStyle={{ minWidth: '50rem' }}>
            <Column field="DATA" header={t('data')}></Column>
            <Column field="CARTORIO" header={t('cartorio')}></Column>
            <Column field="COMARCA" header={t('cidade')}></Column>
            <Column field="UF" header={t('uf')}></Column>
            <Column body={(item) => formatarParaMoedaBRL(Number(item.VALOR.replaceAll('.', '').replace(',', '.')))} field="VALOR" header={t('valor')}></Column>
          </DataTable>
        </>)}
      </Panel>
    )
  }

  const getOcorrenciasPorProvedor = (provedor: string) => {
    if (creditoPositivo.PEND_FINANCEIRAS && creditoPositivo.PEND_FINANCEIRAS.OCORRENCIAS && creditoPositivo.PEND_FINANCEIRAS.OCORRENCIAS.length > 0) {
      return creditoPositivo.PEND_FINANCEIRAS.OCORRENCIAS.filter((ocorrencia: any) => ocorrencia.INFORMANTE === provedor);
    }
    return [];
  }

  const getValorTotalPendencias = () => {
    if (creditoPositivo.PEND_FINANCEIRAS && creditoPositivo.PEND_FINANCEIRAS.OCORRENCIAS && creditoPositivo.PEND_FINANCEIRAS.OCORRENCIAS.length > 0) {
      let valorTotal = 0;
      creditoPositivo.PEND_FINANCEIRAS.OCORRENCIAS.forEach((ocorrencia: any) => {
        valorTotal += Number(ocorrencia.VALOR.replaceAll('.', '').replace(',', '.'));
      });
      return formatarParaMoedaBRL(valorTotal);
    }
    return formatarParaMoedaBRL(0);
  }


  const headerTemplatePendencia = (provedor: string) => (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {getOcorrenciasPorProvedor(provedor).length > 0 ? (<div><span style={{ color: '#C70039' }} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('pendencia') + ' ' + provedor}</span></div>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('pendencia') + ' ' + provedor}</span>)}</div>;
  }

  // Seção de Dados da Receita Federal
  const renderDadosReceitaFederal = () => {
    const dados = creditoPositivo.DADOS_RECEITA_FEDERAL;
    if (!dados) return null;

    const isPJ = dados.TIPO_PESSOA === 'JURIDICA';

    return (
      <Panel header="Dados Receita Federal">
        <div className="grid">
          {/* Campos comuns */}
          {dados.NOME && (
            <div className="col-12 md:col-6 lg:col-4">
              <p><strong>Nome:</strong> {dados.NOME}</p>
            </div>
          )}
          {dados.RAZAO_SOCIAL && (
            <div className="col-12 md:col-6">
              <p><strong>Razão Social:</strong> {dados.RAZAO_SOCIAL}</p>
            </div>
          )}
          <div className="col-12 md:col-6 lg:col-4">
            <p><strong>Tipo Pessoa:</strong> {dados.TIPO_PESSOA || '-'}</p>
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <p><strong>Situação Receita:</strong> {dados.SITUACAO_RECEITA || '-'}</p>
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <p><strong>{isPJ ? 'Data Fundação' : 'Data Nascimento'}:</strong> {dados.DATA_NASCIMENTO_FUNDACAO || '-'}</p>
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <p><strong>Data Atualização:</strong> {dados.DATA_ATUALIZACAO || '-'}</p>
          </div>

          {/* Campos específicos PF */}
          {!isPJ && dados.NOME_MAE && (
            <div className="col-12 md:col-6 lg:col-4">
              <p><strong>Nome da Mãe:</strong> {dados.NOME_MAE}</p>
            </div>
          )}
          {!isPJ && dados.SEXO && (
            <div className="col-12 md:col-6 lg:col-4">
              <p><strong>Sexo:</strong> {dados.SEXO === 'M' ? 'Masculino' : dados.SEXO === 'F' ? 'Feminino' : dados.SEXO}</p>
            </div>
          )}

          {/* Campos específicos PJ */}
          {isPJ && dados.NATUREZA_JURIDICA && (
            <div className="col-12 md:col-6">
              <p><strong>Natureza Jurídica:</strong> {dados.NATUREZA_JURIDICA}</p>
            </div>
          )}
          {isPJ && dados.ATIVIDADE_ECONOMICA_PRINCIPAL && (
            <div className="col-12">
              <p><strong>Atividade Econômica Principal:</strong> {fixEncoding(dados.ATIVIDADE_ECONOMICA_PRINCIPAL)}</p>
            </div>
          )}
          {dados.EMAIL && (
            <div className="col-12 md:col-6 lg:col-4">
              <p><strong>Email:</strong> {dados.EMAIL}</p>
            </div>
          )}
        </div>
      </Panel>
    );
  };

  // Seção de Scores
  const renderScores = () => {
    const scores = creditoPositivo.SCORES;
    if (!scores || !scores.OCORRENCIAS || scores.OCORRENCIAS.length === 0) return null;

    return (
      <Panel header="Scores">
        {scores.OCORRENCIAS.map((score: any, index: number) => (
          <Card key={index} className="mb-3">
            <div className="grid align-items-center">
              <div className="col-12 md:col-6 lg:col-3 flex justify-content-center">
                <div className="text-center">
                  <Score
                    score={score.SCORE}
                    range={getRange(score.SCORE ?? '0')}
                  />

                </div>
              </div>
              <div className="col-12 md:col-6 lg:col-9 flex align-items-center">
                <div>
                  <p><strong>Score:</strong> {score.TIPO_SCORE || score.DESCR_SCORE}</p>
                  <p><strong>Probabilidade de Inadimplência:</strong> {score.PROBABILIDADE_INADIMPLENCIA || '-'}</p>
                  <p><strong>Informante:</strong> {score.INFORMANTE || '-'}</p>
                  <p><strong>Risco:</strong> {score.RISCO || score.TEXTO || '-'}</p>
                </div>
              </div>
            </div>
          </Card>
        ))}
      </Panel>
    );
  };

  // Seção de Renda Presumida
  const renderRendaPresumida = () => {
    const renda = creditoPositivo.RENDA_PRESUMIDA;
    if (!renda) return null;

    return (
      <Panel header="Renda Presumida">
        <div className="grid">
          <div className="col-12 md:col-6 lg:col-4">
            <p><strong>Faixa:</strong> {renda.FAIXA || '-'}</p>
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <p><strong>Descrição:</strong> {renda.DESCRICAO || '-'}</p>
          </div>
          {renda.VALOR_PRESUMIDO && (
            <div className="col-12 md:col-6 lg:col-4">
              <p><strong>Valor Presumido:</strong> {renda.VALOR_PRESUMIDO}</p>
            </div>
          )}
          {renda.RENDA_ANUAL && (
            <div className="col-12 md:col-6 lg:col-4">
              <p><strong>Renda Anual:</strong> {renda.RENDA_ANUAL}</p>
            </div>
          )}
          {renda.DATA_REFERENCIA && (
            <div className="col-12 md:col-6 lg:col-4">
              <p><strong>Data Referência:</strong> {renda.DATA_REFERENCIA}</p>
            </div>
          )}
          {renda.MENSAGEM && (
            <div className="col-12">
              <p><strong>Mensagem:</strong> {renda.MENSAGEM}</p>
            </div>
          )}
        </div>
      </Panel>
    );
  };

  // Seção de Informações, Alertas e Restrições
  const renderInformacoesAlertasRestricoes = () => {
    const info = creditoPositivo.INFORMACOES_ALERTAS_RESTRICOES;
    if (!info || !info.OCORRENCIAS || info.OCORRENCIAS.length === 0) return null;

    return (
      <Panel header="Informações, Alertas e Restrições">
        <DataTable size="small" value={info.OCORRENCIAS} tableStyle={{ minWidth: '50rem' }}>
          <Column field="TITULO"></Column>
          <Column field="OBSERVACOES"></Column>
        </DataTable>
      </Panel>
    );
  };

  // Seção de Endereços
  const renderEnderecos = () => {
    const enderecos = creditoPositivo.SOMENTE_ENDERECO;
    if (!enderecos || !enderecos.DADOS || enderecos.DADOS.length === 0) return null;

    return (
      <Panel header="Endereços">
        <DataTable size="small" value={enderecos.DADOS} tableStyle={{ minWidth: '50rem' }}>
          <Column field="ENDERECO" header="Endereço"></Column>
          <Column field="NUMERO" header="Número"></Column>
          <Column field="COMPLEMENTO" header="Complemento"></Column>
          <Column field="BAIRRO" header="Bairro"></Column>
          <Column field="CIDADE" header="Cidade"></Column>
          <Column field="UF" header="UF"></Column>
          <Column field="CEP" header="CEP"></Column>
        </DataTable>
      </Panel>
    );
  };

  // Seção de Telefone Fixo
  const renderTelefoneFixo = () => {
    const telefones = creditoPositivo.TELEFONE_FIXO;
    if (!telefones || !telefones.TELEFONES || telefones.TELEFONES.length === 0) return null;

    return (
      <Panel header="Telefone Fixo">
        <DataTable size="small" value={telefones.TELEFONES} tableStyle={{ minWidth: '50rem' }}>
          <Column body={(item) => `(${item.DDD}) ${item.NUM_TELEFONE}`} header="Telefone"></Column>
          <Column field="NOME" header="Nome"></Column>
        </DataTable>
      </Panel>
    );
  };

  // Seção de Telefone Celular
  const renderTelefoneCelular = () => {
    const telefones = creditoPositivo.TELEFONE_CELULAR;
    if (!telefones || !telefones.TELEFONES || telefones.TELEFONES.length === 0) return null;

    return (
      <Panel header="Telefone Celular">
        <DataTable size="small" value={telefones.TELEFONES} tableStyle={{ minWidth: '50rem' }}>
          <Column body={(item) => `(${item.DDD}) ${item.NUM_TELEFONE}`} header="Telefone"></Column>
          <Column field="NOME" header="Nome"></Column>
        </DataTable>
      </Panel>
    );
  };

  // Seção de Emails
  const renderEmails = () => {
    const emails = creditoPositivo.EMAILS;
    if (!emails || !emails.INFOEMAILS || emails.INFOEMAILS.length === 0) return null;

    return (
      <Panel header="E-mails">
        <DataTable size="small" value={emails.INFOEMAILS} tableStyle={{ minWidth: '50rem' }}>
          <Column field="ENDERECO" header="E-mail"></Column>
        </DataTable>
      </Panel>
    );
  };

  // Seção de Parentes
  const renderParentes = () => {
    const parentes = creditoPositivo.PARENTES;
    if (!parentes || !parentes.INFOCONTATOS || parentes.INFOCONTATOS.length === 0) return null;

    return (
      <Panel header="Parentes">
        <DataTable size="small" value={parentes.INFOCONTATOS} tableStyle={{ minWidth: '50rem' }}>
          <Column field="NOME" header="Nome"></Column>
          <Column field="RELACAO" header="Relação"></Column>
          <Column field="DOCUMENTO" header="Documento"></Column>
          <Column field="NASCIMENTO" header="Data Nascimento"></Column>
        </DataTable>
      </Panel>
    );
  };

  // Seção de Participação em Empresas
  const renderParticipacaoEmpresas = () => {
    const participacao = creditoPositivo.PARTICIPACAO_EM_EMPRESAS;
    if (!participacao || !participacao.OCORRENCIAS || participacao.OCORRENCIAS.length === 0) return null;

    return (
      <Panel header="Participação em Empresas">
        <DataTable size="small" value={participacao.OCORRENCIAS} tableStyle={{ minWidth: '50rem' }}>
          <Column field="RAZAO_SOCIAL" header="Razão Social"></Column>
          <Column field="CNPJ" header="CNPJ"></Column>
          <Column field="PARTICIPANTE_CARGO" header="Cargo"></Column>
          <Column field="PARTICIPACAO" header="Participação (%)"></Column>
          <Column field="PARTICIPANTE_ENTRADA" header="Data Entrada"></Column>
        </DataTable>
      </Panel>
    );
  };

  // Seção de Veículos
  const renderVeiculos = () => {
    const veiculos = creditoPositivo.VEICULOS_POR_DOCUMENTO;
    if (!veiculos || !veiculos.OCORRENCIAS || veiculos.OCORRENCIAS.length === 0) return null;

    return (
      <Panel header="Veículos">
        <DataTable size="small" value={veiculos.OCORRENCIAS} tableStyle={{ minWidth: '50rem' }}>
          <Column field="MARCA_MODELO" header="Marca/Modelo"></Column>
          <Column field="PLACA" header="Placa"></Column>
          <Column field="ANO_FABRICACAO" header="Ano Fabricação"></Column>
          <Column field="ANO_MODELO" header="Ano Modelo"></Column>
          <Column field="COR" header="Cor"></Column>
          <Column field="COMBUSTIVEL" header="Combustível"></Column>
          <Column field="UF" header="UF"></Column>
          <Column field="SITUACAO" header="Situação"></Column>
        </DataTable>
      </Panel>
    );
  };

  // Seção de Passagens Comerciais
  const renderPassagensComerciais = () => {
    const passagens = creditoPositivo.PASSAGENS_COMERCIAIS;
    if (!passagens) return null;

    const hasOccurrences = passagens.OCORRENCIAS && passagens.OCORRENCIAS.length > 0;

    return (
      <Panel headerTemplate={createHeaderTemplate('Passagens Comerciais', hasOccurrences)}>
        {!hasOccurrences ? (
          <NadaConsta />
        ) : (
          <DataTable size="small" value={passagens.OCORRENCIAS} tableStyle={{ minWidth: '50rem' }}>
            <Column field="DATA_CONSULTA" header="Data Consulta"></Column>
            <Column field="CLIENTE_CONSULTA" header="Cliente"></Column>
            <Column field="CIDADE_UF_CLIENTE" header="Cidade/UF"></Column>
            <Column field="TELEFONE_CLIENTE" header="Telefone"></Column>
          </DataTable>
        )}
      </Panel>
    );
  };

  // Seção de Cheques sem Fundos BACEN
  const renderChequesSemFundos = () => {
    const cheques = creditoPositivo.CH_SEM_FUNDOS_BACEN;
    if (!cheques) return null;

    const hasOccurrences = cheques.OCORRENCIAS && cheques.OCORRENCIAS.length > 0;

    return (
      <Panel headerTemplate={createHeaderTemplate('Cheques sem Fundos - BACEN', hasOccurrences)}>
        {!hasOccurrences ? (
          <NadaConsta />
        ) : (
          <DataTable size="small" value={cheques.OCORRENCIAS} tableStyle={{ minWidth: '50rem' }}>
            <Column field="DATA" header="Data"></Column>
            <Column field="BANCO" header="Banco"></Column>
            <Column field="AGENCIA" header="Agência"></Column>
            <Column field="MOTIVO" header="Motivo"></Column>
            <Column field="QUANTIDADE" header="Quantidade"></Column>
          </DataTable>
        )}
      </Panel>
    );
  };

  // Seção de Cheques sem Fundos Varejo
  const renderChequesSemFundosVarejo = () => {
    const cheques = creditoPositivo.CH_SEM_FUNDOS_VAREJO;
    if (!cheques) return null;

    const hasOccurrences = cheques.OCORRENCIAS && cheques.OCORRENCIAS.length > 0;

    return (
      <Panel headerTemplate={createHeaderTemplate('Cheques sem Fundos - Varejo', hasOccurrences)}>
        {!hasOccurrences ? (
          <NadaConsta />
        ) : (
          <DataTable size="small" value={cheques.OCORRENCIAS} tableStyle={{ minWidth: '50rem' }}>
            <Column field="DATA" header="Data"></Column>
            <Column field="BANCO" header="Banco"></Column>
            <Column field="AGENCIA" header="Agência"></Column>
            <Column field="MOTIVO" header="Motivo"></Column>
            <Column field="QUANTIDADE" header="Quantidade"></Column>
          </DataTable>
        )}
      </Panel>
    );
  };

  // Seção de Contumácia
  const renderContumacia = () => {
    const contumacia = creditoPositivo.CONTUMACIA;
    if (!contumacia) return null;

    const hasOccurrences = contumacia.OCORRENCIAS && contumacia.OCORRENCIAS.length > 0;

    return (
      <Panel headerTemplate={createHeaderTemplate('Contumácia', hasOccurrences)}>
        {!hasOccurrences ? (
          <NadaConsta />
        ) : (
          <>
            <div className="grid mb-3">
              <div className="col-12 md:col-4">
                <p><strong>Quantidade de Ocorrências:</strong> {contumacia.QUANTIDADE_OCORRENCIA || '0'}</p>
              </div>
              <div className="col-12 md:col-4">
                <p><strong>Primeira Ocorrência:</strong> {contumacia.DATA_PRIMEIRA_OCORRENCIA || '-'}</p>
              </div>
              <div className="col-12 md:col-4">
                <p><strong>Última Ocorrência:</strong> {contumacia.DATA_ULTIMA_OCORRENCIA || '-'}</p>
              </div>
            </div>
            <DataTable size="small" value={contumacia.OCORRENCIAS} tableStyle={{ minWidth: '50rem' }}>
              <Column field="DATA" header="Data"></Column>
              <Column field="DESCRICAO" header="Descrição"></Column>
              <Column field="VALOR" header="Valor"></Column>
            </DataTable>
          </>
        )}
      </Panel>
    );
  };

  // Seção de Re-Cheque
  const renderRecheque = () => {
    const recheque = creditoPositivo.RECHEQUE;
    if (!recheque) return null;

    const hasOccurrences = recheque.OCORRENCIAS && recheque.OCORRENCIAS.length > 0;

    return (
      <Panel headerTemplate={createHeaderTemplate('Re-Cheque', hasOccurrences)}>
        {!hasOccurrences ? (
          <NadaConsta />
        ) : (
          <DataTable size="small" value={recheque.OCORRENCIAS} tableStyle={{ minWidth: '50rem' }}>
            <Column field="DATA" header="Data"></Column>
            <Column field="BANCO" header="Banco"></Column>
            <Column field="AGENCIA" header="Agência"></Column>
            <Column field="CONTA" header="Conta"></Column>
            <Column field="CHEQUE" header="Cheque"></Column>
            <Column field="MOTIVO" header="Motivo"></Column>
          </DataTable>
        )}
      </Panel>
    );
  };

  // Seção de Informações da Empresa
  const renderInformacoesEmpresa = () => {
    const info = creditoPositivo.INFORMACOES_DA_EMPRESA;
    if (!info) return null;

    return (
      <Panel header="Informações da Empresa">
        <div className="grid">
          {info.RAZAO_SOCIAL && (
            <div className="col-12 md:col-6">
              <p><strong>Razão Social:</strong> {info.RAZAO_SOCIAL}</p>
            </div>
          )}
          {info.NOME_FANTASIA && (
            <div className="col-12 md:col-6">
              <p><strong>Nome Fantasia:</strong> {info.NOME_FANTASIA}</p>
            </div>
          )}
          {info.CNPJ && (
            <div className="col-12 md:col-6 lg:col-4">
              <p><strong>CNPJ:</strong> {info.CNPJ}</p>
            </div>
          )}
          {info.DATA_FUNDACAO && (
            <div className="col-12 md:col-6 lg:col-4">
              <p><strong>Data Fundação:</strong> {info.DATA_FUNDACAO}</p>
            </div>
          )}
          {info.SITUACAO && (
            <div className="col-12 md:col-6 lg:col-4">
              <p><strong>Situação:</strong> {info.SITUACAO}</p>
            </div>
          )}
          {info.DATA_SITUACAO && (
            <div className="col-12 md:col-6 lg:col-4">
              <p><strong>Data Situação:</strong> {info.DATA_SITUACAO}</p>
            </div>
          )}
          {info.NATUREZA_JURIDICA && (
            <div className="col-12 md:col-6 lg:col-4">
              <p><strong>Natureza Jurídica:</strong> {info.NATUREZA_JURIDICA}</p>
            </div>
          )}
          {info.CAPITAL_SOCIAL && (
            <div className="col-12 md:col-6 lg:col-4">
              <p><strong>Capital Social:</strong> {formatarParaMoedaBRL(Number(info.CAPITAL_SOCIAL))}</p>
            </div>
          )}
          {info.PORTE && (
            <div className="col-12 md:col-6 lg:col-4">
              <p><strong>Porte:</strong> {info.PORTE}</p>
            </div>
          )}
          {info.FAIXA_FUNCIONARIOS && (
            <div className="col-12 md:col-6 lg:col-4">
              <p><strong>Faixa de Funcionários:</strong> {info.FAIXA_FUNCIONARIOS}</p>
            </div>
          )}
          {info.CNAE_PRIMARIO && (
            <div className="col-12">
              <p><strong>CNAE Primário:</strong> {info.CNAE_PRIMARIO}</p>
            </div>
          )}
          {info.CNAE_SECUNDARIO && (
            <div className="col-12">
              <p><strong>CNAE Secundário:</strong> {info.CNAE_SECUNDARIO}</p>
            </div>
          )}
          {info.INSCRICAO_ESTADUAL && (
            <div className="col-12 md:col-6 lg:col-4">
              <p><strong>Inscrição Estadual:</strong> {info.INSCRICAO_ESTADUAL}</p>
            </div>
          )}
          {info.OPCAO_TRIBUTARIA && (
            <div className="col-12 md:col-6 lg:col-4">
              <p><strong>Opção Tributária:</strong> {info.OPCAO_TRIBUTARIA}</p>
            </div>
          )}
          {info.QUANTIDADE_FILIAIS && (
            <div className="col-12 md:col-6 lg:col-4">
              <p><strong>Quantidade Filiais:</strong> {info.QUANTIDADE_FILIAIS}</p>
            </div>
          )}
          {info.TELEFONE && (
            <div className="col-12 md:col-6 lg:col-4">
              <p><strong>Telefone:</strong> {info.TELEFONE}</p>
            </div>
          )}
        </div>
      </Panel>
    );
  };

  // Seção de Quadro Societário
  const renderQuadroSocietario = () => {
    const quadro = creditoPositivo.QUADRO_SOCIETARIO;
    if (!quadro || !quadro.OCORRENCIAS || quadro.OCORRENCIAS.length === 0) return null;

    return (
      <Panel header="Quadro Societário">
        {quadro.RAZAO_SOCIAL && (
          <div className="mb-3">
            <p><strong>Razão Social:</strong> {quadro.RAZAO_SOCIAL}</p>
            {quadro.CNPJ && <p><strong>CNPJ:</strong> {quadro.CNPJ}</p>}
            {quadro.CAPITAL_SOCIAL && <p><strong>Capital Social:</strong> {formatarParaMoedaBRL(Number(quadro.CAPITAL_SOCIAL))}</p>}
            {quadro.ATUALIZACAO_JUNTA_COMERCIAL && <p><strong>Atualização Junta Comercial:</strong> {quadro.ATUALIZACAO_JUNTA_COMERCIAL}</p>}
          </div>
        )}
        <DataTable size="small" value={quadro.OCORRENCIAS} tableStyle={{ minWidth: '50rem' }}>
          <Column field="NOME" header="Nome"></Column>
          <Column field="CPF_CNPJ" header="CPF/CNPJ"></Column>
          <Column field="CARGO" header="Cargo"></Column>
          <Column field="PERCENTUAL_PARTICIPACAO" header="Participação (%)"></Column>
          <Column field="DATA_ENTRADA_SOCIEDADE" header="Data Entrada"></Column>
          <Column field="TIPO_DOCUMENTO" header="Tipo"></Column>
        </DataTable>
      </Panel>
    );
  };

  // Seção de Faturamento Presumido
  const renderFaturamentoPresumido = () => {
    const faturamento = creditoPositivo.FATURAMENTO_PRESUMIDO;
    if (!faturamento) return null;

    return (
      <Panel header="Faturamento Presumido">
        <div className="grid">
          <div className="col-12 md:col-6 lg:col-4">
            <p><strong>Faixa:</strong> {faturamento.FAIXA || '-'}</p>
          </div>
          {faturamento.VALOR_PRESUMIDO && (
            <div className="col-12 md:col-6 lg:col-4">
              <p><strong>Valor Presumido:</strong> {faturamento.VALOR_PRESUMIDO}</p>
            </div>
          )}
          {faturamento.FATURAMENTO_ANUAL && (
            <div className="col-12 md:col-6 lg:col-4">
              <p><strong>Faturamento Anual:</strong> {faturamento.FATURAMENTO_ANUAL}</p>
            </div>
          )}
          {faturamento.DATA_REFERENCIA && (
            <div className="col-12 md:col-6 lg:col-4">
              <p><strong>Data Referência:</strong> {faturamento.DATA_REFERENCIA}</p>
            </div>
          )}
          {faturamento.MENSAGEM && (
            <div className="col-12">
              <p><strong>Mensagem:</strong> {faturamento.MENSAGEM}</p>
            </div>
          )}
        </div>
      </Panel>
    );
  };

  // Seção de Endereço Simples (PJ)
  const renderEnderecoSimples = () => {
    const endereco = creditoPositivo.ENDERECO;
    if (!endereco || (!endereco.ENDERECO && !endereco.CIDADE && !endereco.UF)) return null;

    return (
      <Panel header="Endereço">
        <div className="grid">
          {endereco.ENDERECO && (
            <div className="col-12 md:col-6">
              <p><strong>Endereço:</strong> {endereco.ENDERECO}</p>
            </div>
          )}
          {endereco.BAIRRO && (
            <div className="col-12 md:col-6 lg:col-4">
              <p><strong>Bairro:</strong> {endereco.BAIRRO}</p>
            </div>
          )}
          {endereco.CIDADE && (
            <div className="col-12 md:col-6 lg:col-4">
              <p><strong>Cidade:</strong> {endereco.CIDADE}</p>
            </div>
          )}
          {endereco.UF && (
            <div className="col-12 md:col-6 lg:col-2">
              <p><strong>UF:</strong> {endereco.UF}</p>
            </div>
          )}
          {endereco.CEP && (
            <div className="col-12 md:col-6 lg:col-2">
              <p><strong>CEP:</strong> {endereco.CEP}</p>
            </div>
          )}
        </div>
      </Panel>
    );
  };

  // Seção de Somente Telefone
  const renderSomenteTelefone = () => {
    const telefone = creditoPositivo.SOMENTE_TELEFONE;
    if (!telefone || telefone.REGISTRO_LOCALIZADO === "0") return null;
    if (!telefone.TELEFONES || telefone.TELEFONES.length === 0) return null;

    return (
      <Panel header="Telefones">
        <DataTable size="small" value={telefone.TELEFONES} tableStyle={{ minWidth: '50rem' }}>
          <Column body={(item) => item.DDD && item.NUM_TELEFONE ? `(${item.DDD}) ${item.NUM_TELEFONE}` : item.NUM_TELEFONE || '-'} header="Telefone"></Column>
          <Column field="NOME" header="Nome"></Column>
          <Column field="CIDADE" header="Cidade"></Column>
          <Column field="UF" header="UF"></Column>
        </DataTable>
      </Panel>
    );
  };


  return (
    <div>
      {creditoPositivo.mensagemErro ? (<p>{creditoPositivo.mensagemErro}</p>) :
        (<div>
          <br></br>
          {creditoPositivo.DADOS_RECEITA_FEDERAL && renderDadosReceitaFederal()}
          <br></br>
          {creditoPositivo.INFORMACOES_DA_EMPRESA && renderInformacoesEmpresa()}
          <br></br>
          {/* Scores */}
          {creditoPositivo.SCORES?.OCORRENCIAS?.length > 0 && <>{renderScores()}</>}
          <br></br>
          {/* Informações, Alertas e Restrições */}
          {creditoPositivo.INFORMACOES_ALERTAS_RESTRICOES?.OCORRENCIAS?.length > 0 && <>{renderInformacoesAlertasRestricoes()}</>}
          <br></br>
          {/* Quadro Societário */}
          {creditoPositivo.QUADRO_SOCIETARIO?.OCORRENCIAS?.length > 0 && <>{renderQuadroSocietario()}<br /></>}
          <br></br>
          {creditoPositivo.PEND_FINANCEIRAS && creditoPositivo.PEND_FINANCEIRAS.PROVEDORES && (
            <Panel header="Pendências Financeiras">
              {creditoPositivo.PEND_FINANCEIRAS && creditoPositivo.PEND_FINANCEIRAS.OCORRENCIAS && creditoPositivo.PEND_FINANCEIRAS.OCORRENCIAS.length > 0 && (
                <div style={{ paddingBottom: '2rem', paddingLeft: '5rem' }}><span style={{ padding: '2rem' }}><b>VALOR TOTAL:</b> {getValorTotalPendencias()} </span><span style={{ padding: '2rem' }}><b>QUANTIDADE DE PENDÊNCIAS HOJE:</b> {creditoPositivo.PEND_FINANCEIRAS.QUANTIDADE_OCORRENCIA} </span><span style={{ padding: '2rem' }}><b>ÚLTIMA OCORRÊNCIA:</b> {creditoPositivo.PEND_FINANCEIRAS.ULTIMO_VENCIMENTO} </span></div>
              )}
              {creditoPositivo.PEND_FINANCEIRAS.PROVEDORES.map((provedor: any) => (
                <div>
                  <Panel headerTemplate={headerTemplatePendencia(provedor.PROVEDOR)}>
                    {getOcorrenciasPorProvedor(provedor.PROVEDOR).length === 0 ? (<NadaConsta />) : (<>
                      <DataTable size="small" value={getOcorrenciasPorProvedor(provedor.PROVEDOR)} tableStyle={{ minWidth: '50rem' }}>
                        <Column field="DATA_INCLUSAO" header={t('data')}></Column>
                        <Column field="DATA_VENCIMENTO" header={t('vencimento')}></Column>
                        <Column field="CONTRATO" header={t('contrato')}></Column>
                        <Column field="ORIGEM" header={t('origem')}></Column>
                        <Column field="TIPO_DEVEDOR" header={t('tipo')}></Column>
                        <Column field="CREDOR" header={t('informante')}></Column>
                        <Column body={(item) => formatarParaMoedaBRL(Number(item.VALOR.replace(',', '.')))} field="VALOR" header={t('valor')}></Column>
                      </DataTable>
                    </>)}
                  </Panel>
                  <br></br>
                </div>
              ))}
            </Panel>
          )}
          <br></br>
          {creditoPositivo.PEND_REFIN && (
            <>
              <Panel headerTemplate={headerTemplatePendencia2}>
                {!creditoPositivo.PEND_REFIN.OCORRENCIAS || creditoPositivo.PEND_REFIN.OCORRENCIAS.length === 0 ? (<NadaConsta />) : (<>
                  <DataTable size="small" value={creditoPositivo.PEND_REFIN.OCORRENCIAS} responsiveLayout="stack" breakpoint="960px">
                    <Column field="DATA_INCLUSAO" header={t('data')}></Column>
                    <Column field="DATA_VENCIMENTO" header={t('vencimento')}></Column>
                    <Column field="CONTRATO" header={t('contrato')}></Column>
                    <Column field="ORIGEM" header={t('origem')}></Column>
                    <Column field="TIPO_DEVEDOR" header={t('tipo')}></Column>
                    <Column field="CREDOR" header={t('informante')}></Column>
                    <Column field="VALOR" header={t('valor')}></Column>
                  </DataTable>
                </>)}
              </Panel>
              <br></br>
            </>
          )}
          {creditoPositivo.PEND_VENCIDAS && (
            <>
              <Panel headerTemplate={headerTemplatePendencia3}>
                {!creditoPositivo.PEND_VENCIDAS.OCORRENCIAS || creditoPositivo.PEND_VENCIDAS.OCORRENCIAS.length === 0 ? (<NadaConsta />) : (<>
                  <DataTable size="small" value={creditoPositivo.PEND_VENCIDAS.OCORRENCIAS} responsiveLayout="stack" breakpoint="960px">
                    <Column field="DATA_INCLUSAO" header={t('data')}></Column>
                    <Column field="DATA_VENCIMENTO" header={t('vencimento')}></Column>
                    <Column field="CONTRATO" header={t('contrato')}></Column>
                    <Column field="ORIGEM" header={t('origem')}></Column>
                    <Column field="TIPO_DEVEDOR" header={t('tipo')}></Column>
                    <Column field="CREDOR" header={t('informante')}></Column>
                    <Column field="VALOR" header={t('valor')}></Column>
                  </DataTable>
                </>)}
              </Panel>
              <br></br>
            </>
          )}
          <br></br>
          {creditoPositivo.PROTESTOS && renderProtestoSection(creditoPositivo.PROTESTOS)}
          <br></br>
          {creditoPositivo.PROTESTO_SINTETICO && renderProtestoSection(creditoPositivo.PROTESTO_SINTETICO)}
          <br></br>
          {/* Cheques sem Fundos BACEN */}
          {creditoPositivo.CH_SEM_FUNDOS_BACEN && <>{renderChequesSemFundos()}<br /></>}
          <br></br>
          {/* Faturamento Presumido */}
          {creditoPositivo.FATURAMENTO_PRESUMIDO && <>{renderFaturamentoPresumido()}<br /></>}
          <br></br>
          {/* Renda Presumida */}
          {creditoPositivo.RENDA_PRESUMIDA && <>{renderRendaPresumida()}<br /></>}
          <br></br>
          {/* Veículos */}
          {creditoPositivo.VEICULOS_POR_DOCUMENTO?.OCORRENCIAS?.length > 0 && <>{renderVeiculos()}<br /></>}
          <br></br>
          {/* E-mails */}
          {creditoPositivo.EMAILS?.INFOEMAILS?.length > 0 && <>{renderEmails()}<br /></>}
          <br></br>
          {/* Endereço Simples (PJ) */}
          {creditoPositivo.ENDERECO && (creditoPositivo.ENDERECO.ENDERECO || creditoPositivo.ENDERECO.CIDADE || creditoPositivo.ENDERECO.UF) && <>{renderEnderecoSimples()}<br /></>}
          <br></br>
          {/* Endereços */}
          {creditoPositivo.SOMENTE_ENDERECO?.DADOS?.length > 0 && <>{renderEnderecos()}<br /></>}
          <br></br>
          {/* Telefone Celular */}
          {creditoPositivo.TELEFONE_CELULAR?.TELEFONES?.length > 0 && <>{renderTelefoneCelular()}<br /></>}
          <br></br>
          {/* Telefone Fixo */}
          {creditoPositivo.TELEFONE_FIXO?.TELEFONES?.length > 0 && <>{renderTelefoneFixo()}<br /></>}
          <br></br>
          {/* Somente Telefone */}
          {creditoPositivo.SOMENTE_TELEFONE?.REGISTRO_LOCALIZADO !== "0" && creditoPositivo.SOMENTE_TELEFONE?.TELEFONES?.length > 0 && <>{renderSomenteTelefone()}<br /></>}
          <br></br>
          {/* Passagens Comerciais */}
          {creditoPositivo.PASSAGENS_COMERCIAIS && <>{renderPassagensComerciais()}<br /></>}
          <br></br>
          {/* Participação em Empresas */}
          {creditoPositivo.PARTICIPACAO_EM_EMPRESAS?.OCORRENCIAS?.length > 0 && <>{renderParticipacaoEmpresas()}<br /></>}
          <br></br>
          {/* Parentes */}
          {creditoPositivo.PARENTES?.INFOCONTATOS?.length > 0 && <>{renderParentes()}<br /></>}
          <br></br>
          {/* Contumácia */}
          {creditoPositivo.CONTUMACIA && <>{renderContumacia()}<br /></>}
          <br></br>
          {/* Re-Cheque */}
          {creditoPositivo.RECHEQUE && <>{renderRecheque()}<br /></>}
          <br></br>
          {/* Cheques sem Fundos Varejo */}
          {creditoPositivo.CH_SEM_FUNDOS_VAREJO && <>{renderChequesSemFundosVarejo()}<br /></>}
          <br></br>
        </div>)}
    </div>
  )
}